import script from "./social.vue?vue&type=script&setup=true&lang=js"
export * from "./social.vue?vue&type=script&setup=true&lang=js"

import "./social.vue?vue&type=style&index=0&id=179ef1b2&lang=less"
script.__scopeId = "data-v-179ef1b2"

export default script